import { TuiInput, TuiTextfield } from '@taiga-ui/core';
import { TuiInputYear } from '@taiga-ui/kit';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  OnInit,
} from '@angular/core';
import {
  FormBuilder,
  FormGroupDirective,
  ReactiveFormsModule,
} from '@angular/forms';
import { AttachCarBrandsDirective } from './directives/attach-car-brands.directive';
import { FormPickerComponent } from '@core/components';
import { RequestDTO } from '@core/types/Request';
import { RequestService } from '@core/services/request/request.service';
import { TranslatePipe } from '@ngx-translate/core';

enum FormFields {
  CarBrandId = 'carBrandId',
  CarModel = 'carModel',
  CarType = 'carType',
  VIN = 'carVin',
  CarPlantNumber = 'carPlantNumber',
  CarYear = 'carYear',
  ManufacturerCountry = 'manufacturerCountry',
}

type FormType = Pick<
  RequestDTO,
  | 'carBrandId'
  | 'carModel'
  | 'carType'
  | 'carVin'
  | 'carPlantNumber'
  | 'carYear'
  | 'manufacturerCountry'
>;

@Component({
  selector: 'x-request-form-common-car',
  imports: [
    TuiTextfield,
    ReactiveFormsModule,
    TuiInput,
    FormPickerComponent,
    AttachCarBrandsDirective,
    TuiInputYear,
    TranslatePipe,
  ],
  templateUrl: './request-form-common-car.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestFormCommonCarComponent implements OnInit {
  private readonly formBuilder = inject(FormBuilder);
  private readonly parentForm = inject(FormGroupDirective);
  private readonly requestService = inject(RequestService);
  readonly FormFields = FormFields;
  carMinYear = 2000;
  carMaxYear = new Date().getFullYear();
  formGroup = this.formBuilder.group<FormType>({
    [FormFields.CarBrandId]: null,
    [FormFields.CarModel]: '',
    [FormFields.CarType]: '',
    [FormFields.VIN]: '',
    [FormFields.CarPlantNumber]: '',
    [FormFields.CarYear]: '',
    [FormFields.ManufacturerCountry]: '',
  });

  $readOnly = input<boolean>(false, { alias: 'readOnly' });

  constructor() {
    effect(() => {
      if (this.$readOnly()) {
        this.formGroup.disable();
      }
    });
  }

  ngOnInit() {
    this.formGroup.patchValue(this.requestService.$request());
    this.parentForm.form.addControl('car', this.formGroup);
  }
}
